import { mentalStates } from "@/app/constants";

// Which tone hue (lib/ui/tones.js) a buyer attitude is coloured with, keyed by
// its difficulty. One map for every attitude badge (the assignment page's
// persona row, AttitudeSelector's difficulty headings) so they never drift.
export const ATTITUDE_DIFFICULTY_TONE = {
  easy: "emerald",
  medium: "warning",
  hard: "rose",
};

export function getMentalState(value) {
  if (!value) return null;
  return mentalStates.find((s) => s.value === value) || null;
}

export function getAttitudeDifficulty(value) {
  return getMentalState(value)?.difficulty || null;
}

// Tone hue for an attitude; neutral gray for an unknown value.
export function getAttitudeTone(value) {
  return ATTITUDE_DIFFICULTY_TONE[getAttitudeDifficulty(value)] || "gray";
}
